












import { Component, Prop, Mixins } from 'vue-property-decorator'
import GetColorMixin from '@/mixins/getColor'

@Component({ name: 'talent-test' })
export default class TalentTest extends Mixins(GetColorMixin) {
  @Prop({ type: Boolean, required: false, default: false })
  readonly micro: boolean
  @Prop({ type: Boolean, required: false, default: false })
  readonly small: boolean
}
